<template>
    <ol v-if="need_list">
        <li v-for="(v, k) in domain_ol" :key="k">{{ v }}</li>
    </ol>
    <slot name="other"></slot>
    <div class="flex" v-if="need_help">
        
        <p class="hint">Need help? 
            <!-- <router-link :to="'/help'"> Contact support</router-link> -->
            <a
                :href="`mailto:${$store.state.mail_to}?subject=${$store.state.user_data.merchant_account ? $store.state.user_data.merchant_account.merchant_display_name + ' - ' : ''}Support Request&amp;body=Please%20describe%20your%20issue%20below%20in%20as%20much%20detail%20as%20possible%20(including%20what%20device%20you're%20using%20and%20screenshots,%20if%20necessary).%20A%20support%20team%20member%20will%20contact%20you%20within%201-2%20business%20days.`"
                target="_blank">
                Contact support
            </a>
        </p>
        <slot name="btn">
        </slot>
    </div>
</template>

<script>

export default {
    name: 'DomainOl',
    props: {
        need_list: {
            type: Boolean,
            default: true
        },
        
        need_help: {
            type: Boolean,
            default: true
        },

        domain_ol: {
            type: Array,
            default: []
        }
    },

    components: {

    },


}
</script>


